import IUserRepository from "../4_Repositories/IUserRepository";

export default class CurrentUserUseCase {
  private readonly _userRepository: IUserRepository;

  constructor(UserRepository: IUserRepository) {
    this._userRepository = UserRepository;
  }

  public async execute() {
    const userEntity = await this._userRepository.current();
    return userEntity?.toJSON();
  }
}
